import React, { Component } from "react";

import './services.css';

export class Services extends Component {
  render() {
    return (
      <div id="services" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Nossos produtos</h2>
            <p>
              Confira abaixo o que nós oferecemos que pode ser de seu interesse.
            </p>
          </div>
          <div className="row">
            {this.props.data
              ? this.props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  {" "}
                  {d.icon && <i className={d.icon}></i>}
                  {d.img && <img src={d.img} alt={d.name} className="product-img"></img>}
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    {d.text && <p>{d.text}</p>}
                  </div>
                </div>
              ))
              : "loading"}
          </div>
        </div>
      </div>
    );
  }
}

export default Services;
